class DateFormater {
    static formatNumber(number) {
        return number
            ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            : null;
    }
}

export default DateFormater;
